<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="my-schizophrenia-intro">
<h1>1<br/> My Schizophrenia Intro</h1>
<div class="section level3" id="pre-episode-i">
<h3>Pre-episode I</h3>
<p style="text-indent:0em !important;">In my last year of school, I had lost a friend who was battling cancer. After I finished school and started studying medicine, I lost the person that I loved the most in this life: my grandmother. That’s when I started smoking cannabis as a way to cope with my loss. I started getting this back pain that just wouldn’t go away. A year went by. I was studying and slowly sliding into a psychosis. The pain was intensifying and by that point, I had been to many different doctors and no one could tell me where the pain was coming from. I was losing hope. I was tired and felt like there was no escaping this pain.</p>
</div>
<div class="section level3" id="episode-1">
<h3>Episode 1</h3>
<p>I was eighteen when I had my first episode. It was almost the end of the second year of medicine. I was under a lot of stress; that’s when the psychosis started to manifest itself.</p>
<p>My first episode lasted a bit over a month before I was sent away from Sudan to Tunisia, where I was supposed to seek professional help. I stayed in Tunisia for a couple of months where I was seeing a psychiatrist once a week, but she failed to diagnose me and said everything would be fine. Little did she know it was only going to get worse!</p>
</div>
<div class="section level3" id="pre-episode-ii">
<h3>Pre-episode II</h3>
<p>I had decided to go to Germany to take a language course in Dusseldorf. The pain was still there and was intensifying. I started getting depressed and had persistent suicidal thoughts. A year had gone by and I was again losing hope. By that point, I had been to many doctors and no one could help. They gave me pain killers that weren’t too effective. I was desperate to find a solution for my pain or at least find the cause. I insisted on getting a brain scan, which was when a tumour was found, and I was told by that doctor that I had approximately five years to live. A short while after that, the second episode started!</p>
</div>
<div class="section level3" id="episode-2">
<h3>Episode 2</h3>
<p>My second episode lasted for a couple of months before I was taken to the right doctor, who finally diagnosed me with schizophrenia! I was given a lot of antipsychotic medication and a promise that the pain would finally go away.</p>
</div>
<div class="section level3" id="the-road-to-recovery">
<h3>The road to recovery</h3>
<p>It has been almost five years now that I have been taking my medication. During this time, I have experienced a lot of symptoms and side effects, from hallucinations to pain, dizziness, skin rashes and palpitations. It has been tough, but overall, when I look back, I can see that I am moving in the right direction. As time moves on, I keep getting to know myself better and always finding ways to cope and deal with this unpredictable condition. One thing that I have learned is that the mind is a powerful tool that can change your perception of your surroundings, way of thinking and reality. I have experienced some things that words fail to describe. It’s been a tough yet beautifully strange journey, and I have no idea where it is going to take me next.</p>
</div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch006.vue?41a358fa